// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3W9aF","col":"CardReaderDesc_col__21g6i","label":"CardReaderDesc_label__nINSU"};